<section class="mt-2 pr-2">
    <h4>{{translate.getLng('EDIT_ADDR')}}</h4>
    <sen-app-customer-data (emitAddress)="emitAddress($event)" [type]="type" [data]="data"></sen-app-customer-data>
</section>